import PropTypes from 'prop-types';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

import styles from './styles/CheckoutReviewStepChargesDisclaimer.scss';

const CheckoutReviewStepChargesDisclaimer = props => {
    const { transaction: transactionRef } = props;

    const transaction = useFragment(
        graphql`
            fragment CheckoutReviewStepChargesDisclaimer_transaction on Transaction {
                isShippingKnownAtCheckout
                mostRecentOffer {
                    quantity
                }
                isNegotiable
            }
        `,
        transactionRef
    );

    const quantity = transaction?.mostRecentOffer?.quantity;
    const showOfferDisclaimer = transaction?.isNegotiable;
    const showChargeDisclaimer =
        !!quantity && !transaction.isShippingKnownAtCheckout && !showOfferDisclaimer;

    if (!showChargeDisclaimer && !showOfferDisclaimer) {
        return null;
    }

    return (
        <div className={styles.wrapper} data-tn="checkout-review-charges-disclaimer">
            {showOfferDisclaimer && (
                <div className={styles.disclaimer}>
                    <span className={styles.disclaimerEmphasis}>
                        <FormattedMessage
                            id="checkout.CheckoutReviewStepChargesDisclaimer.offerMessage"
                            defaultMessage="You will only be charged if the seller accepts your offer. Offers are valid for 7 days."
                        />
                    </span>
                </div>
            )}
            {showChargeDisclaimer && (
                <div className={styles.disclaimer}>
                    <span className={styles.disclaimerEmphasis}>
                        <FormattedMessage
                            id="checkout.CheckoutReviewStepChargesDisclaimer.approvalMessage"
                            defaultMessage="You will only be charged upon your approval."
                        />
                    </span>
                </div>
            )}
        </div>
    );
};

CheckoutReviewStepChargesDisclaimer.propTypes = {
    transaction: PropTypes.object.isRequired,
};

export default CheckoutReviewStepChargesDisclaimer;
